<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="cbp-spmenu-push">
    <!-- banner -->
    <div class="banner">
      <div class="container">
        <div class="banner-info">
          <span>技術・製品</span>
        </div>
      </div>
    </div>
    <!-- banner-bottom -->
    <section>
      <!-- 设计中心 -->
      <section id="sjzx">
        <div class="container gradient-background">
          <div class="row">
            <div class="col-lg-12 rzTop">
              <h1><span>エンジニアリングサービス</span></h1>
              <p>
                華胤グループは、現代的な設計理念と国家の関連基準に基づいて工事設計を行っています。同社は自社の設計センターを有し、鋼構造設計における甲級認定を取得しており、江蘇省海安市および昆山市にそれぞれ拠点を置く強力な専門設計チームを擁しています。国際的に先進的なMBS、X-STEEL、PKPM、3D3S、STAADPRO、MBS、MTS、CFS、XSTEELなどの設計ソフトウェアを採用し、構造設計から製造詳細図までの一貫した設計作業を実現できます。これまでに4,000件以上の設計経験を積み、さまざまな分野にわたって活躍しています。また、完全な鋼構造の製作および設置図面を提供することで、製作および施工を正確かつ効率的に進めることができます。
              </p>
              <div class="container-fluid">
                <div
                  class="col-lg-6 col-xs-6"
                  v-for="(item, index) in sjzxList"
                  :key="index"
                >
                  <div class="sjzxImg">
                    <img :src="item.image" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 系统产品 -->
          <section id="xtcp">
            <div class="row">
              <div class="col-lg-12 xtTop">
                <h1><span>鋼構造製品</span></h1>
              </div>
            </div>

            <div class="container-fluid">
              <div
                class="col-lg-6 col-xs-6"
                v-for="(item, index) in xtList"
                :key="index"
                @click="openModal(index)"
              >
                <div class="xtImg">
                  <img :src="item.image" alt="" />
                  <p class="xtp">{{ item.text }}</p>
                </div>
              </div>
            </div>
            <div v-if="isModalOpen" class="modal">
              <div class="modal-content">
                <span class="xmodaltop">鋼構造製品</span>
                <!-- 关闭按钮 -->
                <span class="xclose" @click="closeModal">&times;</span>
                <!-- 详细内容 -->
                <div class="xxd">
                  <el-carousel
                    :autoplay="false"
                    trigger="click"
                    indicator-position="outside"
                    :initial-index="this.selectedIndex"
                  >
                    <el-carousel-item
                      v-for="(item, index) in xtxqList"
                      :key="index"
                    >
                      <div class="col-lg-12 xxnrbor">
                        <div class="content">
                          <div class="img-container visible-lg">
                            <img :src="item.image" alt="Lazy-loaded Image" />
                          </div>
                          <div class="text-container col-xs-12">
                            <h3>{{ item.htext }}</h3>
                            <img
                              :src="item.image"
                              alt="Lazy-loaded Image"
                              class="hidden-lg"
                            />
                            <p style="white-space: pre-line">
                              {{ item.ptext }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </div>
          </section>

          <!-- 华胤专利 -->
          <section id="hyzl">
            <div class="row">
              <div class="col-lg-12 rzTop">
                <h1><span>特許技術</span></h1>
                <p>
                  華胤は工場の建築技術の研究開発に力を入れており、新型系杆、屋根通気装置、屋根鋼板の風雪抵抗固定台など12件の鋼構造特許を取得しています。これにより、工場のエネルギー消費を削減し、耐久性の向上が図られています。
                </p>
              </div>
            </div>
            <div>
              <h2>
                <span class="hspan"
                  ><span style="color: red">///////// </span>特許証明書</span
                >
              </h2>
            </div>
            <div class="container-fluid">
              <div
                class="col-lg-1-5 col-xs-4"
                v-for="(item, index) in jtzlList"
                :key="index"
              >
                <div class="portfolio-item">
                  <div class="thumb">
                    <div class="image">
                      <div class="demo-image__preview jtzlImg">
                        <el-image
                          style="height: 100%"
                          :src="item.image[0]"
                          :preview-src-list="item.image"
                        >
                        </el-image>
                      </div>
                    </div>
                    <div class="hover-effect">
                      <div
                        class="hover-content jtzlHeight"
                        style="white-space: pre-line"
                      >
                        <h1>{{ item.text }}</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- 安裝服務 -->
          <section id="azfw">
            <div class="row">
              <div class="col-lg-12 rzTop">
                <h1><span>施工・据付サービス</span></h1>
                <p>
                  華胤はすでに4,000件以上のプロジェクトを成功裏に完了し、豊富なプロジェクト管理の経験を蓄積しています。プロジェクトマネージャー制度を採用することで、効率的に工事管理と現場サービスを実施しています。プロジェクトマネージャーは、発注者、設計院、監理機関、政府関係部門および他の請負業者と緊密に連携し、プロジェクトの円滑な進捗を実現しています。具体的かつ効果的な対策により、現場作業における安全要件を確実に確保しています。また、充実したアフターサービスにより、顧客が後顧の心を抱かずに済む環境を提供しています。
                </p>
              </div>
              <div class="col-lg-12 azTop">
                <img
                  src="@/components/img/cpyfw/azfw.jpg"
                  alt=""
                  style="width: 85vw"
                />
              </div>
            </div>
          </section>

          <!-- 新能源 -->
          <section id="gsxny">
            <div class="row">
              <div class="col-lg-12 nyTop">
                <h1><span>工場再生可能エネルギ</span></h1>
                <p>
                  華胤グループでは、持続可能な製造環境の構築を目的として、自社工場の屋根を活用した太陽光発電プロジェクトを推進しています。<br />再生可能エネルギーの活用により、工場の電力需要の一部を自給するとともに、CO₂排出量の削減と環境負荷の低減に取り組んでいます。
                </p>
              </div>
              <div class="col-lg-12">
                <div class="xnyNum">
                  <div class="xnytitle">NO.1 国盛発電所</div>
                  <div>
                    <carousel-3d
                      :controlsVisible="true"
                      :width="cWidth"
                      :height="cHeight"
                      :display="5"
                      :space="280"
                    >
                      <slide :index="0">
                        <img
                          v-lazy="hyxny1"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="1">
                        <img
                          v-lazy="hyxny2"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="2">
                        <img
                          v-lazy="hyxny3"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="3">
                        <img
                          v-lazy="hyxny4"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="4">
                        <img
                          v-lazy="hyxny5"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                    </carousel-3d>
                  </div>
                  <div class="xnyContent">
                    <p>
                      分散型太陽光発電とは、ユーザーの場所の近くに建設され、ユーザー側で自給自足し、余剰電力を送電網に送り、配電システムのバランス調整を特徴とする太陽光発電施設を指す。太陽光モジュールを使用して、太陽エネルギーを直接電気に変換する分散型発電システムである。発電は近隣で行い、電力系統には近隣で接続し、電気変換も近隣で行い、使用も近隣で行うことで、同等規模の太陽光発電所の発電量を効果的に向上させるとともに、昇圧および長距離輸送における電力損失を効果的に解消することができる。
                      最も広く普及している分散型太陽光発電システムは、都市部の建物屋根に設置された太陽光発電プロジェクトである。この種のプロジェクトは必ず公共電力網に接続され、公共電力網と連携して近隣のユーザーに電力を供給しなければならない。
                    </p>
                  </div>
                </div>
                <div class="xnyNum">
                  <div class="xnytitle">NO.2 森鋼発電所</div>
                  <div>
                    <carousel-3d
                      :controlsVisible="true"
                      :width="cWidth"
                      :height="cHeight"
                      :display="5"
                      :space="280"
                    >
                      <slide :index="0">
                        <img
                          v-lazy="hyxny6"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="1">
                        <img
                          v-lazy="hyxny7"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="2">
                        <img
                          v-lazy="hyxny8"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="3">
                        <img
                          v-lazy="hyxny9"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="4">
                        <img
                          v-lazy="hyxny10"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                    </carousel-3d>
                  </div>
                  <div class="xnyContent">
                    <p>
                      森鋼発電所は、華胤グループが建設に参画した大型工場屋根設置の太陽光発電プロジェクトで、総設置容量は2MW（2000kW）に達し、高効率の分散型太陽光発電システム（Distributed
                      Solar System）に属し、産業製造工場に広く適用されます。<br />
                      本プロジェクトは安徽森鋼組立製造有限公司の工場屋根に設置され、カラー鋼板屋根構造を採用し、575Wpの高効率単結晶太陽光モジュールを合計3,478枚配置し、高密度発電配置を実現して屋根スペースの利用効率を最大化しています。<br />
                      システムは「自家消費、余剰電力を電網に送電」方式で運用され、380V低圧の系統連系で工場の電力システムに接続され、企業の電力コストを効果的に削減するとともに、エネルギーの自立性を向上させます。<br />
                      電力変換面では、本プロジェクトは16台のストリング型インバータ（575kW級）を配置し、さらに複数の系統連系キャビネットを新設して、太陽光で発電された直流電力を交流電力に変換後、既存の電力システムを通じて電力消費端に送電し、システムの安定かつ高効率な運転を確保しています。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
      <!-- 邮箱 -->
      <div class="mailbg">
        <to-mail button-text="お問い合わせ"></to-mail>
      </div>
      <!-- 小滾輪 -->
      <div id="ss_menu">
        <div>
          <i><a @click="forId('sjzx')">デザイン</a></i>
        </div>
        <div>
          <i
            ><a @click="forId('xtcp')">鋼構造<br />製品</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('hyzl')">特許<br />技術</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('azfw')">施工<br />交付</a></i
          >
        </div>
        <div>
          <i><a @click="forId('gsxny')">新エネルギー</a></i>
        </div>
        <div class="menu">
          <div class="share" id="ss_toggle" data-rot="180">
            <div class="circle"></div>
            <div class="bar"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isModalOpen: false, // 控制模态框的显示状态
      selectedIndex: 0,
      sjzxList: [
        {
          image: require('@/components/img/cpyfw/sjzx1.png'),
        },
        {
          image: require('@/components/img/cpyfw/sjzx2.png'),
        },
        {
          image: require('@/components/img/cpyfw/sjzx3.png'),
        },
        {
          image: require('@/components/img/cpyfw/sjzx4.png'),
        },
      ],
      xtList: [
        {
          image: require('@/components/img/cpyfw/xtcp1.jpg'),
          text: '換気システム',
        },
        {
          image: require('@/components/img/cpyfw/xtcp2.jpg'),
          text: '屋根システム',
        },
        {
          image: require('@/components/img/cpyfw/xtcp3.jpg'),
          text: '採光システム',
        },
        {
          image: require('@/components/img/cpyfw/xtcp4.jpg'),
          text: '梁枠（りょうほう）',
        },
        {
          image: require('@/components/img/cpyfw/xtcp5.jpg'),
          text: '階層システム',
        },
        {
          image: require('@/components/img/cpyfw/xtcp6.jpg'),
          text: '主鋼システム',
        },
        {
          image: require('@/components/img/cpyfw/xtcp7.jpg'),
          text: '壁面システム',
        },
        {
          image: require('@/components/img/cpyfw/xtcp8.jpg'),
          text: 'プレキャスト構造',
        },
      ],
      xtxqList: [
        {
          image: require('@/components/img/cpyfw/cpjs1.jpg'),
          htext: '華胤換気システム',
          ptext:
            '室内の温度差によって発生する熱力学的エネルギーと、室内外の自然風が形成する風力を利用し、建物の低層壁面にある空気の入口から新鮮な空気を吸い込み、内部の温かい排気ガスや有毒ガスを換気口から排出することで、排気効果を達成します。機械式換気システムと比較して、以下の利点があります：経済性が高い、自動的に換気量を調節可能、静かで振動がない、専門的な設計により設置が迅速かつ簡単です。',
        },
        {
          image: require('@/components/img/cpyfw/cpjs2.jpg'),
          htext: '華胤屋根システム',
          ptext:
            'SD屋根システム :専用の密閉式スライド固定座と360度両面巻き取り接合により、気密性が高く、台風耐性に優れ、断熱効果も良好で、漏水防止性能が高い。  \nLD屋根システム :LD屋根パネルは、2つの専用固定座を互いに噛み合う方式（サンドイッチ方式）で接続・固定しており、完璧な防水・防風・防雪性能と高い耐荷重能力を備えている。  \nKD屋根システム :専用の隠蔽式固定座と鋼板を噛み合う方式で接続する屋根システムで、強力な耐風性と優れた漏水防止性能を実現。熱膨張や冷収縮時に鋼板が可動するため、鋼板の損傷を防ぐことができる。  \nCD二層屋根システム :ボルトが直接鋼板を貫通して固定するシステムで、一般的な経済型屋根システムであり、特殊な接続方式により、効果的に風雨や漏水を防ぐことができる。  \nVD高波屋根システム :特徴的なV字形の波峰構造を採用し、波峰の高さは176mmと高い排水深度を実現。最大ラーメン間隔は3メートルまで可能で、360度ロックシームおよびスライド固定座技術を採用しているため、大スパン・大ラーメン間隔の建築物に最適。',
        },
        {
          image: require('@/components/img/cpyfw/cpjs3.jpg'),
          htext: '華胤採光システム',
          ptext:
            '採光板は、建築物に使用される材料であり、効率的かつ無害な自然光を提供します。その設計と構造により、室内に十分な自然光が得られ、人工照明への依存を減らすことができます。従来の照明設備と比べて、採光板は電力を必要としないため、エネルギー消費や電気代の支出を削減できます。\nさらに、採光板の表面にはコーティングが施されており、一定の機能性を備えています。紫外線99.9％を遮断するため、室内の人員や物品を紫外線によるダメージから効果的に保護します。また、表面コーティングは耐老化・変色性にも優れており、板材の外観や性能を長期間安定させ、寿命を延ばすことができます。\n透過率：透明色（70％）、乳白色（58％）。',
        },
        {
          image: require('@/components/img/cpyfw/cpjs4.jpg'),
          htext: '次構造システム',
          ptext:
            '次構造システムは、建築物の屋根パネルと壁面パネルを接続・支えるための支持構造であり、通常、屋根梁や柱に取り付けられます。このシステムにおいて、ラーメン（檩条）は重要な構成要素で、屋根パネルと壁面パネルを横方向に連結する支持構造を担っています。ラーメンの材質は、高強度の連続熱浸漬亜鉛めっきまたはアルミ亜鉛めっき鋼板が一般的で、優れた耐食性を備えており、過酷な環境下でも長期間使用できるようになっています。また、ラーメンの表面は滑らかで美観が良く、屋根や壁面により良い外観効果を提供できます。ラーメンには主に「C」型と「Z」型の2種類があります。「C」型ラーメンは断面形状が文字「C」に似ており、通常は屋根パネルの支持に用いられます。一方、「Z」型ラーメンは断面形状が文字「Z」に似ており、通常は壁面パネルの支持に使用されます。これらのラーメンの種類は、建物の具体的な要件に応じて選択および設置することができます。',
        },
        {
          image: require('@/components/img/cpyfw/cpjs5.jpg'),
          htext: '多層システム',
          ptext:
            '低層プレハブ鋼構造システムと同様の特徴を備えており、従来の鉄筋コンクリート構造に比べて、多層鋼構造システムは工期を大幅に短縮し、施工品質を管理できます。階間の厚さと柱のサイズを最小限に抑えることで、建築高さを削減でき、より多くの使用空間を確保するとともに、建築面積を節約し、不必要な熱エネルギーおよび空調供給を削減します。軽量な構造により地盤への負荷が軽減され、地盤コストの節約も可能です。床は華胤の組み合わせ式フロアパネルを現場でコンクリートと一体成型することができます。あらゆる気象条件下でも迅速に施工可能なこの楼承板システムは、軽量性、高い強度対重量比、耐久性と美観性といった特長から、長年にわたり設計者たちから高く評価されています。',
        },
        {
          image: require('@/components/img/cpyfw/cpjs6.jpg'),
          htext: '主構造システム',
          ptext:
            '主構造は、鋼構造建築全体を支える鋼梁と鋼柱で、H形鋼を溶接して作られています。材料は工事設計に基づき、国家標準のQ235BまたはQ345B鋼材を使用しています。各プロジェクトの特殊な条件に応じて、複数のフレーム形式から選択可能です。\n先進的な自動溶接設備により、溶接部の品質および部材の品質が国家基準に達することを保証します。輸入の多方向スプレーランク装置を採用し、錆を完全に除去します。表面には防錆下塗りを施すことで、鋼構造物の最適な防錆機能を確保します。',
        },
        {
          image: require('@/components/img/cpyfw/cpjs7.jpg'),
          htext: '華胤壁面システム',
          ptext:
            'CDII壁面システム :ネジが外側に露出するため、一般的に経済的で、取り付けが容易。あらゆる建築物に適しています。  \nRD壁面システム :独特の波形設計により、ネジは波溝内に半隠しになっており、壁面全体の外観が明確で上品です。一般的に経済的で、取り付けが簡単。あらゆる建築物に適しています。  \nPD壁面システム :PD壁板は互いに噛み合う隠蔽接続方式を採用しており、表面にはネジが露出しません。40mm厚の壁体内に余裕があり、より厚い断熱材を挟むことで断熱効果を高めることができます。  \nPU50/MW60サンドイッチシステム :2枚のカラーフェンス鋼板で構成されたパネル。PU50ポリウレタンとMW60ロックウールの2種類の芯材を使用し、滑らかな特殊な低凹部と歯状の縞模様を実現します。  \nCP二重壁板システム :華胤のいずれかの屋根パネルとLND内層パネルで構成され、中間にガラス繊維断熱材を挟んでいます。内層パネルは屋根の内側に滑らかな表面を提供すると同時に、屋根の断熱層を保護します。',
        },
        {
          image: require('@/components/img/cpyfw/cpjs8.jpg'),
          htext: '低層プレハブ鋼構造システム',
          ptext:
            '低層プレハブ鋼構造システムは、すべての材料が鋼を主体とし、先進的な設計ソフトウェアによる最適化設計を経て工場で高精度加工された後、現場では積み木のように接続部品で組み立てられる現代的な建築システムです。現場での溶接や加工は一切不要です。\n特徴：工期が短く,品質管理が容易,メンテナンスコストが低い,実用面積が広い,柱間隔は製造工程に応じて配置可能。外観がモダンで美しく、拡張が容易。適用範囲：あらゆる業種の工場、物流倉庫、航空機庫、造船所など、広大かつ大スパンの建築物に適しています。',
        },
      ],
      jtzlList: [
        {
          image: [require('@/components/img/cpyfw/zlzs1.jpg')],
          text: '新型V型ラック',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs2.jpg')],
          text: '新型防風フック付きプレート',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs3.jpg')],
          text: '屋根通気装置',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs4.jpg')],
          text: '屋根用金属板取り付け装置',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs5.jpg')],
          text: '屋根鋼板の耐風構造固定台',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs6.jpg')],
          text: '手動開閉装置',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs7.jpg')],
          text: '凹凸型押花鋼製の床板',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs8.jpg')],
          text: '対称二重補強条鋼製床板',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs9.jpg')],
          text: 'カーテンドアの風防装置',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs10.jpg')],
          text: '鋼板接合式屋根',
        },
      ],
      hyxny1: require('@/components/img/cpyfw/xny1.png'),
      hyxny2: require('@/components/img/cpyfw/xny2.png'),
      hyxny3: require('@/components/img/cpyfw/xny3.png'),
      hyxny4: require('@/components/img/cpyfw/xny4.png'),
      hyxny5: require('@/components/img/cpyfw/xny5.png'),
      hyxny6: require('@/components/img/cpyfw/xny6.png'),
      hyxny7: require('@/components/img/cpyfw/xny7.png'),
      hyxny8: require('@/components/img/cpyfw/xny8.png'),
      hyxny9: require('@/components/img/cpyfw/xny9.png'),
      hyxny10: require('@/components/img/cpyfw/xny10.png'),
    }
  },
  methods: {
    // 調用全局方法，滾動指定id
    forId(tId) {
      console.log(tId)
      this.$store.dispatch('toID', tId)
    },

    // 打开模态框
    openModal(index) {
      console.log(index)

      this.selectedIndex = index
      this.isModalOpen = true
      console.log(this.selectedIndex)
    },
    // 关闭模态框
    closeModal() {
      this.isModalOpen = false
    },
    //改变高度
    changeHeight() {
      if (document.body.clientWidth >= 2000) {
        this.cWidth = 1300
        this.cHeight = 700
      } else if (document.body.clientWidth >= 768) {
        this.cWidth = 900
        this.cHeight = 400
      } else if (document.body.clientWidth < 768) {
        this.cWidth = 1000
        this.cHeight = 400
      }
    },
  },
  mounted() {
    // 獲取高度
    window.onresize = () => {
      this.changeHeight()
    }
  },
  created() {
    this.changeHeight()
  },
  updated() {
    if (this.scrollToElement) {
      this.scrollToElement()
      this.scrollToElement = null
    }
  },
}
</script>

<style scoped>
/* 榮譽圖片註釋設置 */
#xtcp .row,
#hyzl .row,
#azfw .row,
#gsxny .row {
  border-top: 1px solid #000;
}
.cbp-spmenu-push {
  overflow-x: hidden;
  position: relative;
  left: 0;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.cbp-spmenu-push .banner {
  background: url(@/components/img/cpyfw/1.jpg) 0px 0px no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
  height: 500px;
  position: relative;
  width: 100%;
  background-size: 100% 100%;
}

/*-- banner-info --*/
.banner-info {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.banner-info span {
  font-size: 50px;
  color: #fff;
  padding: 0 10px;
  margin: 0 auto;
  line-height: normal;
  background: rgba(0, 0, 0, 0.6);
  font-weight: 700;
}
/***** Lexi *****/
/* 小滾輪 */
@-webkit-keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
  }
}

@-moz-keyframes badbounce {
  0%,
  100% {
    -moz-transform: translateY(0px);
  }
  10% {
    -moz-transform: translateY(6px);
  }
  30% {
    -moz-transform: translateY(-4px);
  }
  70% {
    -moz-transform: translateY(3px);
  }
  90% {
    -moz-transform: translateY(-2px);
  }
}

@keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
    -moz-transform: translateY(6px);
    -ms-transform: translateY(6px);
    -o-transform: translateY(6px);
    transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
    -moz-transform: translateY(-4px);
    -ms-transform: translateY(-4px);
    -o-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
    -moz-transform: translateY(3px);
    -ms-transform: translateY(3px);
    -o-transform: translateY(3px);
    transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}

.ss_animate {
  -webkit-animation: badbounce 1s linear;
  -moz-animation: badbounce 1s linear;
  animation: badbounce 1s linear;
}

#ss_menu {
  z-index: 999;
  bottom: 10px;
  width: 60px;
  height: 60px;
  color: #fff;
  position: fixed;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  right: 15px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

#ss_menu > .menu {
  padding: 32px 0 !important;
  position: absolute;
  border-radius: 50%;
  width: 60px;
  height: 60px !important;
  text-align: center;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.23), 0 3px 10px rgba(0, 0, 0, 0.16);
  color: #fff;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share .circle {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  top: 50%;
  margin-top: -6px;
  left: 12px;
  opacity: 1;
}

#ss_menu > .menu .share .circle:after,
#ss_menu > .menu .share .circle:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  opacity: 1;
  display: block;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
}

#ss_menu > .menu .share .circle:after {
  left: 20.78461px;
  top: 12px;
}

#ss_menu > .menu .share .circle:before {
  left: 20.78461px;
  top: -12px;
}

#ss_menu > .menu .share .bar {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  left: 18px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(30deg);
  -moz-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  -o-transform: rotate(30deg);
  transform: rotate(30deg);
}

#ss_menu > .menu .share .bar:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  left: 0px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

#ss_menu > .menu .share.close .circle {
  opacity: 0;
}

#ss_menu > .menu .share.close .bar {
  top: 50%;
  margin-top: -1.5px;
  left: 50%;
  margin-left: -12px;
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(405deg);
  -moz-transform: rotate(405deg);
  -ms-transform: rotate(405deg);
  -o-transform: rotate(405deg);
  transform: rotate(405deg);
}

#ss_menu > .menu .share.close .bar:before {
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(-450deg);
  -moz-transform: rotate(-450deg);
  -ms-transform: rotate(-450deg);
  -o-transform: rotate(-450deg);
  transform: rotate(-450deg);
}

#ss_menu > .menu.ss_active {
  background: #415160;
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -o-transform: scale(0.7);
  transform: scale(0.7);
}

#ss_menu > div {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 60px;
  height: 60px;
  font-size: 13px;
  text-align: center;
  background: #415160;
  border-radius: 50%;
  display: table;
}

#ss_menu > div i {
  display: table-cell;
  vertical-align: middle;
}
#ss_menu > div a {
  color: #ffffff;
  text-decoration: none;
}
#ss_menu > div:hover {
  background: #2a2f34;
  cursor: pointer;
}

#ss_menu div:nth-child(1) {
  top: 0px;
  left: -180px;
}

#ss_menu div:nth-child(2) {
  top: -70px;
  left: -160px;
}

#ss_menu div:nth-child(3) {
  top: -130px;
  left: -130px;
}

#ss_menu div:nth-child(4) {
  top: -160px;
  left: -70px;
}

#ss_menu div:nth-child(5) {
  top: -180px;
  left: 0px;
}

.carousel-3d-slide {
  background-color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.hspan,
.hspan2 {
  display: inline-block;
  position: relative;
  padding: 10px 20px;
  font-size: 30px;
  font-weight: 600;
}

.sjzxImg {
  position: relative; /* 父容器设为相对定位 */
  width: 100%;
  height: 28vw; /* 按需设置高度 */
  overflow: hidden; /* 防止图片溢出 */
  margin: 15px 0;
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}

.xtImg {
  position: relative; /* 父容器设为相对定位 */
  width: 100%;
  height: 10vw; /* 按需设置高度 */
  overflow: hidden; /* 防止图片溢出 */
  margin: 15px 0;
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}

.xtImg img,
.sjzxImg img {
  width: 100%;
  height: 100%;
}

.xtp {
  position: absolute;
  top: 50%; /* 父容器高度的50% */
  left: 50%; /* 父容器宽度的50% */
  transform: translate(-50%, -50%); /* 修正自身宽高偏移 */
  background: rgba(128, 128, 128, 0.7); /* 灰色半透明背景 */
  color: white;
  padding: 10px 80px; /* 文字内边距 */
  border-radius: 4px; /* 可选：圆角 */
  text-align: center;
  font-size: 30px;
  width: 40vw;
}

.container-fluid {
  margin: 60px auto;
}

.rzTop {
  margin: 60px 0;
  text-align: center;
}
.azTop {
  margin-bottom: 100px;
  text-align: center;
}
.rzTop h1 {
  margin: 50px 0;
}
.rzTop h1 span {
  padding-bottom: 0px;
  font-size: 37px;
  font-weight: 800;
}
.rzTop p,
.nyTop p {
  margin: 0 auto;
  width: 85vw;
  text-align: left;
  font-size: 26px;
  line-height: 40px;
}

.nyTop {
  margin: 60px 0;
  text-align: center;
}
.nyTop h1 {
  margin: 50px 0;
}
.nyTop h1 span {
  padding-bottom: 0px;
  font-size: 37px;
  font-weight: 800;
}

.zzzsHeight {
  height: 70px;
}
.sjzxHeight {
  height: 70px;
}
.jtzlHeight {
  height: 70px;
}
.hover-content h1 {
  font-size: 24px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.gradient-background {
  padding: 0 85px 100px;
  border-top: 1px solid #000;
  width: 100%;
  height: 100%; /* 設置高度為視口高度 */
  background: linear-gradient(
    to right,
    #ccc 0%,
    /* 左邊灰色 */ #ccc 5%,
    /* 灰色延伸到 25% */ #fff 20%,
    #fff 80%,
    /* 中間白色 */ #ccc 95%,
    /* 灰色延伸到 75% */ #ccc 100% /* 右邊灰色 */
  );
}

.mailbg {
  background: linear-gradient(
    to right,
    #ccc 0%,
    /* 左邊灰色 */ #ccc 5%,
    /* 灰色延伸到 25% */ #fff 20%,
    #fff 80%,
    /* 中間白色 */ #ccc 95%,
    /* 灰色延伸到 75% */ #ccc 100% /* 右邊灰色 */
  );
}

.xtTop {
  margin-top: 60px;
  text-align: center;
}
.xtTop h1 {
  margin-top: 50px;
}
.xtTop h1 span {
  padding-bottom: 0px;
  font-size: 37px;
  font-weight: 800;
}

/* 模态框样式 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  position: relative;
  background-color: #58585a;
  padding: 70px 0;
  border-radius: 8px;
  max-width: 100vw;
  height: 100vh;
  text-align: center;
}

.xmodaltop {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 40px;
  color: #fff;
  text-align: center;
  width: 90vw;
}

/* 关闭按钮 */
.xclose {
  position: absolute;
  top: 10px;
  right: 25px;
  font-size: 30px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  background: #fff;
  border-radius: 50%;
  opacity: 1;
}

.xxd {
  width: 100vw;
  height: auto;
  max-height: 90%;
}

.xxImg {
  max-width: 100%;
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.xxp {
  padding: 5px;
}

.jtzlImg {
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}

div /deep/ .jtzlImg img {
  padding: 5px;
  width: 100%;
  overflow: hidden;
  height: 10vw;
  border: 0;
}

/* 新能源 */
.xnytitle {
  font-size: 60px; /*設置文字大小*/
  color: #000; /*設置文字顔色*/
  font-weight: bolder; /*設置文字寬度*/
  text-align: center; /*設置文字居中*/
}
.xnyNum {
  margin: 20px;
  padding: 20px;
  border: 1px solid black;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.xnyContent {
  margin: 10px;
  font-size: 24px;
  max-width: 100%;
}

.xxnrbor {
  padding: 0 100px;
  height: 80vh;
}

div /deep/ .el-carousel__container {
  height: 90vh;
}

div /deep/ .el-carousel__arrow {
  height: 50px;
  width: 50px;
  font-size: 33px;
}

div /deep/ .el-carousel__arrow--right {
  right: 34px;
}

/* 系统 */
.content {
  position: absolute;
  left: 50%;
  top: 55%;
  transform: translate(-50%, -50%);
  width: 90vw;
  display: flex;
}

.content .img-container {
  float: left;
  margin-right: 20px;
}

.content .img-container img {
  width: 40vw;
  height: 70vh;
}

.content .text-container {
  border: 1px solid #000;
  border-radius: 10px;
  float: right;
  background-color: #fff;
  height: auto;
}
.content .text-container h3 {
  padding: 10px;
  margin: 0;
  text-align: center;
  font-size: 22px;
}
.content .text-container p {
  padding: 15px;
  font-size: 18px;
  line-height: 1.6;
  text-align: left;
}
.content .img-container img {
  border: 3px solid #fff;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
}

/* 指示灯 */
div /deep/.el-carousel__indicators--horizontal {
  position: absolute;
  left: 50%;
  bottom: 10px;
  transform: translate(-50%, 0);
  text-align: center;
}
div /deep/.el-carousel__indicator--horizontal button {
  width: 12px;
  height: 12px;
  background: #ffffff;
  border-radius: 50%;
  opacity: 0.5;
}
div /deep/.el-carousel__indicator--horizontal.is-active button {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #fff;
  opacity: 1;
}

@media screen and (max-width: 1400px) {
  .xxnrbor {
    padding: 0 100px;
    height: 83vh;
  }

  .onlyPC {
    display: inline;
  }
  .container {
    padding: 0;
  }
  .nyTop {
    margin: 60px 0 30px;
  }
  .xnyNum {
    margin: 20px 60px;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .container-fluid {
    margin: 15px auto;
  }
  .hspan {
    font-size: 22px;
  }
  .xnytitle {
    font-size: 25px;
  }
  .xnyContent {
    font-size: 19px;
    margin: 0;
  }
  .banner-info p {
    font-size: 28px;
  }
  .rzTop h1 span,
  .xtTop h1 span,
  .nyTop h1 span {
    font-size: 25px;
  }
  .gradient-background {
    padding: 0;
    background: white;
  }
  .mailbg {
    background: white;
  }
  .rzTop p,
  .nyTop p {
    margin: 0 auto;
    width: 85vw;
    text-align: left;
    font-size: 19px;
    font-weight: 500;
    line-height: 20px;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 5px 10px;
  }
  .sjzxImg {
    margin: 5px 0;
  }
  .xtImg {
    margin: 5px 0;
    height: 25vw;
  }
  .xtp {
    padding: 0;
    font-size: 24px;
  }
  .hover-content h1 {
    font-size: 18px;
    margin: 10px 0;
  }
  .jtzlHeight {
    height: 50px;
  }

  div /deep/ .jtzlImg img {
    height: 20vw;
  }
  .rzTop {
    margin: 0;
  }
  .content .text-container img {
    width: 80vw;
    height: 25vw;
  }
  .xxd {
    margin: 0;
  }
  .row {
    padding: 0;
  }
  .content .text-container p {
    padding: 5px;
    font-size: 16px;
    line-height: 1.5;
  }
  .xclose {
    top: 5px;
    right: 5px;
    font-size: 21px;
    width: 30px;
    height: 30px;
  }

  .banner-info span {
    font-size: 30px;
  }
  .cbp-spmenu-push .banner {
    height: 350px;
  }

  div /deep/ .el-carousel__container {
    height: 95vh;
  }
  div /deep/ .el-carousel__arrow {
    height: 40px;
    width: 40px;
    font-size: 25px;
    background-color: rgba(31, 45, 61, 0.5);
  }

  div /deep/ .el-carousel__arrow--right {
    right: 5px;
  }
  div /deep/ .el-carousel__arrow--left {
    left: 5px;
  }

  /* 指示灯 */
  div /deep/.el-carousel__indicators--horizontal {
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translate(-50%, 0);
    text-align: center;
  }
  div /deep/.el-carousel__indicator--horizontal button {
    width: 10px;
    height: 10px;
  }
  div /deep/.el-carousel__indicator--horizontal.is-active button {
    width: 18px;
    height: 18px;
  }
  .content .text-container {
    height: 83vh;
  }
  .modal-content {
    padding: 45px 0;
  }
  .xmodaltop {
    top: 18px;
    font-size: 26px;
  }
  .azTop {
    margin-bottom: 50px;
    margin-top: 20px;
  }
}

@media screen and (max-width: 768px) {
  .onlyPC {
    display: inline;
  }
  .container {
    padding: 0;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .xnyNum {
    margin: 20px 20px;
  }
  .hspan {
    font-size: 20px;
  }
  .xnytitle {
    font-size: 20px;
  }
  .xnyContent {
    font-size: 13px;
    margin: 0;
  }
  .banner-info p {
    font-size: 28px;
  }
  .rzTop h1 span,
  .xtTop h1 span,
  .nyTop h1 span {
    font-size: 20px;
  }
  .gradient-background {
    padding: 0;
    background: white;
  }
  .mailbg {
    background: white;
  }
  .rzTop p,
  .nyTop p {
    margin: 0 auto;
    width: 85vw;
    text-align: left;
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 0 5px;
  }
  .sjzxImg {
    margin: 5px 0;
  }
  .xtImg {
    margin: 5px 0;
    height: 25vw;
  }
  .xtp {
    padding: 0;
    font-size: 16px;
  }
  .hover-content h1 {
    font-size: 13px;
    margin: 10px 0;
  }
  .jtzlHeight {
    height: 50px;
  }

  div /deep/ .jtzlImg img {
    height: 20vw;
  }
  .rzTop {
    margin: 0;
  }
  .content .text-container img {
    width: 80vw;
    height: 25vw;
  }
  .xxd {
    margin: 0;
  }
  .row {
    padding: 0;
  }
  .content .text-container p {
    padding: 5px;
    font-size: 13px;
    line-height: 1.5;
  }
  .xclose {
    top: 5px;
    right: 5px;
    font-size: 22px;
    width: 30px;
    height: 30px;
  }

  .banner-info span {
    font-size: 27px;
  }
  .cbp-spmenu-push .banner {
    height: 200px;
  }

  div /deep/ .el-carousel__container {
    height: 95vh;
  }
  div /deep/ .el-carousel__arrow {
    height: 40px;
    width: 40px;
    font-size: 25px;
    background-color: rgba(31, 45, 61, 0.5);
  }

  div /deep/ .el-carousel__arrow--right {
    right: 5px;
  }
  div /deep/ .el-carousel__arrow--left {
    left: 5px;
  }

  /* 指示灯 */
  div /deep/.el-carousel__indicators--horizontal {
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translate(-50%, 0);
    text-align: center;
  }
  div /deep/.el-carousel__indicator--horizontal button {
    width: 10px;
    height: 10px;
  }
  div /deep/.el-carousel__indicator--horizontal.is-active button {
    width: 18px;
    height: 18px;
  }
  .content .text-container {
    height: 80vh;
  }
  .modal-content {
    padding: 37px 0;
  }
  .xmodaltop {
    top: 18px;
    font-size: 26px;
  }
  .azTop {
    margin-bottom: 50px;
    margin-top: 20px;
  }
}

@media screen and (min-width: 2000px) {
  .page-heading .heading-content h1 {
    font-size: 40px;
  }
  .xnyContent {
    margin: 30px;
    font-size: 29px;
    line-height: 1.5;
  }
  .banner-info span {
    font-size: 65px;
  }
  .rzTop h1 span {
    font-size: 40px;
  }
  .rzTop p,
  .nyTop p {
    font-size: 29px;
    line-height: 1.5;
  }
  .xtp {
    font-size: 38px;
  }
  .hover-content h1 {
    font-size: 26px;
    line-height: 1.5;
  }
  .hover-content h1 {
    height: 100px;
  }
  .nyTop h1 span {
    font-size: 40px;
  }
  .content .text-container h3 {
    font-size: 35px;
  }
  .content .text-container p {
    font-size: 25px;
  }
  .jtzlHeight {
    height: 100px;
  }
  .xtTop h1 span {
    font-size: 40px;
  }
}
</style>
